import PasswordUpdateSuccess from './PasswordUpdateSuccess';

export default PasswordUpdateSuccess;